<template>
  <div class="open-app">
    <p>앱을 여는 중입니다... 잠시만 기다려주세요.</p>
    <img
      class="loading-gif"
      src="@/assets/images/loading-icon.gif"
      alt="loading"
    />
    <a ref="realLink" :href="link" style="display: none">이동</a>
  </div>
</template>

<script>
export default {
  computed: {
    link(){
      const encoded = encodeURIComponent(this.$route.fullPath.split("target=")[1]);
      return  `openapp?target=${encoded}`;

    }
    // link() {
    //   const query = new URLSearchParams(this.$route.fullPath.split("?")[1]);
    //   if (query == false) {
    //     return "openapp?target=";
    //   }
    //   // 1. target 값만 분리
    //   const target = query.get("target");
    //   const [targetPath, utmParamsRaw] = target.split("?");

    //   const utmParams = utmParamsRaw ? utmParamsRaw.replace(/\?/g, "&") : "";

    //   // 2. openapp URL에 target을 먼저 붙임
    //   let openAppUrl = `openapp?target=${encodeURIComponent(targetPath)}`;

    //   // 3. utm_* 같은 나머지 파라미터들 추가
    //   query.delete("target");
    //   if (utmParams) {
    //     utmParams.split("&").forEach((param) => {
    //       const [key, value] = param.split("=");
    //       openAppUrl += `&${key}=${encodeURIComponent(
    //         decodeURIComponent(value)
    //       )}`;
    //     });
    //   }
    //   // 3. target 외부에 있던 파라미터들도 추가
    //   query.forEach((value, key) => {
    //     openAppUrl += `&${key}=${encodeURIComponent(
    //       decodeURIComponent(value)
    //     )}`;
    //   });

    //   return openAppUrl;
    // },
  },
  mounted() {
    this.$refs.realLink.click();
  },
};
</script>

<style scoped>
.open-app {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  font-size: 18px;
  flex-direction: column;
}
.loading-gif {
  padding-top: 20px;
  width: 15%;
}
</style>